<template>
    <div class="upload">
        <p class="center bold">可瀚学堂上传协议</p>
        <p>为更好地方便您使用可瀚学堂产品及作品管理相关服务，您应当阅读并遵守<span class="blue">《可瀚学堂用户协议》</span> 、<span class="blue">《可瀚学堂隐私政策》</span> 等相关协议、规则。请您务必审慎阅读、充分理解各条款内容。</p>
        <p class="bold">一、用户行为</p>
        <p>1、用户在趣味配音和表演大厅中上传配音或视频，过程中点击“确认上传”按钮（或实际使用服务）即表示用户完全接受本规则《可瀚学堂用户协议》和《可瀚学堂隐私政策》。</p>
        <p>2、用户同意，其提交、发布或显示的信息将对其他用户及第三方服务及网站可见。</p>
        <p>3、用户知悉、理解并同意授权可瀚学堂及其关联公司在全球范围内、完全免费、可转授权地使用用户通过可瀚学堂提交、发布或显示的内容（如学员中英文名、学员头像、上传作品、作品名称等），前述内容的形式包括但不限于文字、图片、视频等（以下称“内容”）。具体来说，使用方式包括但不限于：</p>
        <p>（1）将前述内容通过可瀚学堂自身或其他第三方技术、网络等在可瀚学堂选择的网络平台、应用程序或产品中，以有线或无线网，通过免费的方式在不同终端（包括但不限于电脑、手机、互联网电视、及其他上网设备等）以不同形式（包括但不限于点播、直播、下载等）进行网络传播或电信增值服务；</p>
        <p>（2）将前述内容以复制、展览、放映、发行、修改、改编、翻译及其他法律允许的方式在可瀚学堂当前已知或以后开发的作品、媒体或技术中使用，用于相关用途开发或可瀚学堂推广宣传等；</p>
        <p>（3）将前述内容授权给网络媒体、运营商平台等与可瀚学堂有合作的媒体或运营商播放、传播，用于可瀚学堂相关推广宣传；</p>
        <p>（4）其他可瀚学堂及其关联公司出于善意或另行取得用户授权的使用行为。 用户对可瀚学堂及其关联公司的前述授权并不改变用户依法对内容享有的所有权及知识产权，也并不影响用户行使其对发布内容的合法权利；可瀚学堂将尽最大的商业努力合理使用用户的授权内容，但并不代表可瀚学堂及其关联公司承诺一定会使用该内容。</p>
        <p>4、未经可瀚学堂事先书面许可，用户不得自行授权任何第三方使用内容，包括但不限于自行授权任何第三方发表、复制、转载、更改、引用、链接、下载、同步或以其他方式使用部分或全部内容等。</p>
        <p>5、用户同意并授权可瀚学堂以可瀚学堂名义就侵犯用户合法权益的行为（包括但不限于私自复制、使用、编辑、抄袭、在第三方平台上再次发布内容等行为）采取任何形式的法律行为，包括但不限于投诉、诉讼等必要的维权措施。</p>
        <p>6、可瀚学堂有权直接将本规则项下权利义务委托给可瀚学堂的关联公司或其他第三方公司进行运营、管理及履行，可瀚学堂无需就此向用户另行获取授权。可瀚学堂将竭尽避免前述委托或变更给用户使用服务造成的不便。</p>
        <p class="bold">二、具体规则</p>
        <p>1、对于用户发表或存储在可瀚学堂（及/或可瀚学堂委托的第三方）的内容，用户应当自行不定期进行备份。用户在使用可瀚学堂服务期间及终止使用可瀚学堂服务后，可瀚学堂均无义务向用户返还或提供任何数据或内容。</p>
        <p>2、为维护可瀚学堂的稳定运营，确保用户体验质量，未经可瀚学堂事先书面许可，任何人不得擅自在可瀚学堂上实施自动化行为或发布垃圾信息。自动化行为，是指以用户自行或委托他人采用自动化手段或明显异于常人的、远高于正常用户频率地发布信息、作出关注、点赞、抓取数据等的行为。垃圾信息，是指未经可瀚学堂同意，擅自发布营销信息、无意义信息。</p>
        <p>3、用户知悉并同意，可瀚学堂有权根据技术规则通过检测验证等方式判断用户帐号行为是否构成自动化行为、用户帐号所发布的信息是否为垃圾信息，并采取相关措施予以处理。所有处理措施所依据的数据及信息（包括但不限于帐号操作记录、上传内容等）均以可瀚学堂后台记录为准。</p>
        <p class="bold">三、免责声明</p>
        <p>1、凡用户上传的内容，版权责任由用户自负，可瀚学堂仅提供存放空间并供用户展示之用。可瀚学堂有权对上传内容进行筛选，审核，排版，推荐。可瀚学堂有权不事先通知用户即撤消或删除上传内容，并无需向用户承担任何责任。</p>
        <p>2、可瀚学堂并不担保所提供的服务一定能满足用户的要求，也不担保提供的服务不会被中断、终止，并且对服务的及时性，安全性，出错发生均不作任何担保。作者自行留存原稿，可瀚学堂对因任何原因导致用户上传的内容灭失均不承担责任。</p>
        <p>3、用户通过可瀚学堂发布的任何信息，及通过可瀚学堂传递的任何观点不代表可瀚学堂的立场，可瀚学堂亦不对其完整性、真实性、准确性或可靠性负责。用户对于可能会接触到的非法的、非道德的、错误的或存在其他失宜之处的信息，及被错误归类或是带有欺骗性的发布内容，应自行做出判断。在任何情况下，对于任何信息（包括但不仅限于其发生的任何错误或遗漏）或是由于使用通过可瀚学堂服务发布、传达、其他方式所释出的或在别处传播的信息，而造成的任何损失或伤害，应由相关行为主体承担全部责任。</p>
        <p>4、可瀚学堂提供的产品或服务，如未标明使用期限、或者其标明的使用期限为“永久”、“无限期”或“无限制”的，则其使用期限为自用户获得该服务之日起至该产品或服务在可瀚学堂下线之日为止。</p>
        <p class="bold">四、违约责任</p>
        <p>1、 如可瀚学堂发现、或收到第三方举报或投诉获知，用户存在或涉嫌违反本规则第一条（用户行为）、或第二条（具体规则）的，可瀚学堂或其授权主体有权依据其合理判断不经通知立即采取一切必要措施以减轻或消除用户行为造成的影响，并将尽可能在处理之后对用户进行通知。由此造成的损失及后果由用户自行独立承担。</p>
        <p>2、除本规则另有约定外，如可瀚学堂发现、或收到第三方举报或投诉获知，用户存在或涉嫌违反本规则中约定的义务、保证、承诺或其他条款，用户应在可瀚学堂指定期限内予以纠正并消除影响；若用户未在前述时限内予以纠正的，可瀚学堂或其授权主体有权依据其合理判断立即采取一切必要措施以减轻或消除用户行为造成的影响，并将尽可能在处理之后对用户进行通知。由此造成的损失及后果由用户自行独立承担。本规则所述的“一切必要措施”包括但不限于以下一项或多项：</p>
        <p>（1）更改、删除或屏蔽相关内容；</p>
        <p>（2）变更、限制或禁止违规帐号部分或全部功能；</p>
        <p>（3）暂停、限制或终止用户使用可瀚学堂服务的权利、注销用户帐号等；</p>
        <p>（4）向有关监管部门或国家机关报告；</p>
        <p class="bold">五、规则修改</p>
        <p>1、可瀚学堂有权随时修改本规则的任何条款，一旦本规则的内容发生变动，可瀚学堂将会在可瀚学堂平台公布修改之后的规则内容，可瀚学堂也可选择通过其他适当方式（比如系统通知）向用户通知修改内容。</p>
        <p>2、如果不同意可瀚学堂对本规则相关条款所做的修改，用户有权停止使用可瀚学堂服务。如果用户继续使用可瀚学堂服务，则视为用户接受可瀚学堂对本规则相关条款所做的修改。</p>
    </div>
</template>

<script>
    export default {
        created() {
            document.title = '可瀚学堂上传协议'
        }
    }
</script>

<style scoped lang="scss">
    .upload{
        margin: 0 26px 0 19px;
        padding-bottom: 50px;
        color: #7a7988;
        font-size: 15px;
        & > p {
              margin-top: 22px;
              line-height: 20px;
          }
        .bold{
            font-weight: bold;
        }
        .blue{
            color: #24b8fe;
        }
        .center{
            text-align: center;
        }
    }
</style>